import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { OpenStatementsComponent } from './open-statements/open-statements.component';
import { FormatNegativeValuePipe } from './statement-display/format-negative-value.pipe';
import { StatementDisplayComponent } from './statement-display/statement-display.component';

@NgModule({
  declarations: [
    OpenStatementsComponent,
    StatementDisplayComponent,
    FormatNegativeValuePipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    NgbModule,
    MatProgressSpinnerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        StatementTopBodyComponent: {
          component: OpenStatementsComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [NgbActiveModal],
  exports: [OpenStatementsComponent, StatementDisplayComponent],
})
export class StatementsModule {}
